import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"
import install from '../asset/image/install.png'; // Điều chỉnh đường dẫn tùy thuộc vào cấu trúc thư mục của bạn
import summary from '../asset/image/summary.png'; // Điều chỉnh đường dẫn tùy thuộc vào cấu trúc thư mục của bạn
import scan from '../asset/image/scanToPDF.png'; // Điều chỉnh đường dẫn tùy thuộc vào cấu trúc thư mục của bạn
import api from '../asset/image/api.png'; // Điều chỉnh đường dẫn tùy thuộc vào cấu trúc thư mục của bạn

const Benifits = () => {
    const images = [install, summary, scan, api];

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,          // Enable autoplay
        autoplaySpeed: 3000,     // Set autoplay speed to 1000 milliseconds (1 second)
    };
    return (
        <div className="">
            <div className="container" id="About">
                <div id="about" className="flex justify-center section-heading p-4">
                    <h4>How to Summarize Udemy Video</h4>
                </div>
                <div className="flex flex-col sm:flex-row mx-auto">
                    <div className="w-full sm:w-1/2 p-4">
                        {/* Nội dung của cột 1 */}
                        <div className="bg-white p-4 mt-3 text-justify  ">
                            <h2 className="text-lg font-semibold mb-2 text-justify">1. Install And Pin Extension</h2>
                            <span className="text-justify">Install the extension from the browser store and pin it to the toolbar for easy access.</span>
                            <button
                                type="button"
                                className="mt-3 mb-3 bg-violet-500 hover:bg-violet-600 focus:outline-none focus:ring focus:ring-violet-300 active:bg-violet-700 px-5 py-2 text-sm leading-5 rounded-md font-semibold text-white"
                                onClick={() => window.open("https://chromewebstore.google.com/detail/udemy-summary-harness-the/dcclmkicpmnakdmgehlbbcagfpkdpkdl", "_blank")}
                            >
                                Add to browser
                            </button>

                            <h2 className="text-lg font-semibold mb-2 mt-5">2. Click icon ChatGPT </h2>
                            <span >Click the summary button will switch to ChatGPT summary.</span>

                            <h2 className="text-lg font-semibold mb-2 mt-5">3. Download pdf full course</h2>
                            <span >Click the button PDF to download pdf full course.</span>
                            <h2 className="text-lg font-semibold mb-2 mt-5">4. Summary all course and automatically generate summaries directly within the Udemy interface</h2>
                            <span >Click on the settings icon, then input the prompt and API key.</span>

                        </div>
                    </div>
                    {/* Cột 2 */}
                    <div className="w-full sm:w-1/2 p-4">
                        {/* Nội dung của cột 2 */}
                        <div className="bg-white p-4 ">
                            <Slider {...sliderSettings}>
                                {images.map((image, index) => (
                                    <img key={index} src={image} alt={`Slide ${index}`} className="w-full h-auto" />
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Benifits;
